import { FullAudit, IsActiveFlag, UserModel, LevelModel } from '@/types';

export interface UserLabelModel extends IsActiveFlag, FullAudit {
    id: number;
    levelId: number;
    level: LevelModel;
    label: string;
    users: UserModel[];
}
